// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    if (!burgerButton) {
        return;
    }
    burgerButton.addEventListener('click', function () {
        const isOpen = document.body.classList.toggle('gh-head-open');
        burgerButton.setAttribute('aria-expanded', String(isOpen));
        burgerButton.setAttribute('aria-label', isOpen ? 'Menu sluiten' : 'Menu openen');
    });
}
